//Link boxes slider
document.querySelectorAll(".link-boxes-container.slide-layout").forEach(container => {
    const wrapper = container.querySelector(".link-boxes_wrapper");
    const prevBtn = container.querySelector(".button-prev");
    const nextBtn = container.querySelector(".button-next");

    if (!wrapper || !prevBtn || !nextBtn) return;

    const scrollAmount = wrapper.clientWidth / 1.5; // Adjust based on need

    prevBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });

    nextBtn.addEventListener("click", () => {
        wrapper.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });
});
